module.exports = "https://static.wagwalking.com/_next/static/images/wellness-desktop-v2-d6e5c805c47ec88ce822528c428bae6e.png";